module.exports = __webpack_public_path__ + "img/tr.226de5f5.png";